import { ClusterStore } from "$/stores/ClusterStore";
export function getSelectionFromGlobalIndex(globalIndex, clusters) {
    let cumulativeCount = 0;
    for (let clusterIndex = 0; clusterIndex < clusters.length; clusterIndex++) {
        const cluster = clusters[clusterIndex];
        if (cumulativeCount + cluster.topics.length > globalIndex) {
            return { clusterIndex, topicIndex: globalIndex - cumulativeCount };
        }
        cumulativeCount += cluster.topics.length;
    }
    return { clusterIndex: 0, topicIndex: 0 }; // Default to first if not found
}
export function getGlobalIndex(topicIndex, clusterIndex, clusters) {
    var _a;
    let index = 0;
    for (let i = 0; i < clusterIndex; i++) {
        index += (_a = clusters[i]) === null || _a === void 0 ? void 0 : _a.topics.length;
    }
    index += topicIndex;
    return index;
}
let originalClusterStates = new Map();
export function filterClusterTopicsByQuery(query, clusters) {
    if (!clusters)
        return [];
    if (!query) {
        originalClusterStates.forEach((originalState, clusterKey) => {
            const [id, clusterType] = clusterKey.split(':');
            const cluster = clusters.find((c) => String(c.id) === id && c.clusterType === clusterType);
            if (cluster) {
                const currentState = ClusterStore.isCollapsed(cluster);
                if (currentState !== originalState) {
                    ClusterStore.toggleCollapsed(cluster);
                }
            }
        });
        originalClusterStates.clear();
        return clusters;
    }
    return clusters.reduce((filteredClusters, cluster) => {
        var _a;
        const clusterKey = `${cluster.id || 'null'}:${cluster.clusterType}`;
        const isCurrentlyCollapsed = ClusterStore.isCollapsed(cluster);
        if (!originalClusterStates.has(clusterKey)) {
            originalClusterStates.set(clusterKey, isCurrentlyCollapsed);
        }
        const matchingTopicsInCluster = ((_a = cluster.topics) === null || _a === void 0 ? void 0 : _a.filter((topic) => topic.name.toLowerCase().includes(query.toLowerCase()))) || [];
        if (matchingTopicsInCluster.length) {
            if (isCurrentlyCollapsed) {
                ClusterStore.toggleCollapsed(cluster);
            }
            filteredClusters.push(Object.assign(Object.assign({}, cluster), { topics: matchingTopicsInCluster }));
        }
        return filteredClusters;
    }, []);
}
export function addHoverClass(e) {
    const target = e.currentTarget;
    target.classList.add("hover");
}
export function removeHoverClass(e) {
    const target = e.currentTarget;
    target.classList.remove("hover");
}
